import React, {useState} from 'react'
import {AUDIENCE} from '../../../../../utils/constants'
import {FormControlLabel, Stack, Grid, Radio, Typography} from '@mui/material'
import RadioGroup from '@mui/material/RadioGroup'
import questionResponseTemplate from '../../../../../utils/questionResponseTemplate'
import {Config} from '../../../../../utils/Config'
import {IconButton} from '@mui/material'
import SurveyEmoji from '../../../../common/SurveyEmoji'
import {DummyImage} from '../../../../common/DummyImage'
import QuestionCategory from '../../../../../utils/questionCategory'
import TextField from '@mui/material/TextField'
import QuestionCategoryBadge from '../QuestionCategoryBadge'

export default function YesNoMayRender({
  question,
  audience,
  updateAnswers,
  language,
}) {
  const [value, setValue] = useState(null)
  const [response, setResponse] = useState({
    ...questionResponseTemplate,
    questionId: question.id,
    hasNumValue: question.hasCustomValue,
    participantTypeText:
      audience === AUDIENCE.STAFF
        ? 'Staff'
        : audience === AUDIENCE.PARENT
          ? 'Parent'
          : 'Pupil',
    questionTypeText: question.questionType === 4 ? 'Yes/No' : 'Yes/No/May',
  })

  const setSelectedOption = option => {
    
    setValue(option)
    let resp = {
      ...response,
      followupComment:
        question.hasFollowup &&
        question?.followupQuestions?.findIndex(
          x => x.followupValue == value?.value
        ) > -1
          ? response.followupComment
          : null,
    }
    if (language !== 'en') {
      resp[`valueText1`] =
        audience === AUDIENCE.STAFF
          ? option.staffTextEnglish
          : AUDIENCE.PARENT == audience
            ? option.parentTextEnglish
            : option.pupilTextEnglish

      resp['staffQuestion'] = question.staffTextEnglish
      resp['parentQuestion'] = question.parentTextEnglish
      resp['studentQuestion'] = question.pupilTextEnglish
    } else {
      resp[`valueText1`] =
        audience === AUDIENCE.STAFF
          ? option.staffText
          : AUDIENCE.PARENT == audience
            ? option.parentText
            : option.pupilText

      resp['staffQuestion'] = question.staffText
      resp['parentQuestion'] = question.parentText
      resp['studentQuestion'] = question.pupilText
    }

    resp[`numValue1`] =
      question.hasCustomValue && option.numValue ? option.numValue : null

    question?.multiOptionResponseAttributes.map((op, i) => {
      if (op.value === option.value) {
        resp[`value${i + 1}`] = option.value
      } else {
        resp[`value${i + 1}`] = null
      }
    })

    if (question.categoryId) {
      let category = QuestionCategory.getQuestionCategoryFromId(
        question.categoryId
      )
      resp.categoryId = question.categoryId
      resp.categoryName = category ? category.name : null
    }

    setResponse(resp)
    if (updateAnswers) {
      updateAnswers(resp)
    }
  }

  return (
    <Grid container>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Stack direction="column" alignItems="center" spacing={1.5}>
          {/* <QuestionCategoryBadge categoryName={question.categoryName} /> */}
          <Typography variant="h1">
            {AUDIENCE.STAFF === audience
              ? question.staffText
              : AUDIENCE.PARENT == audience
                ? question.parentText
                : question.pupilText}
          </Typography>
        </Stack>
      </Grid>

      {question.image && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <img
            src={`${Config.BASE_URL}/Artifact/download?fileName=${question.image}`}
            alt="question image"
            style={{width: 150, height: 'auto'}}
          />
        </Grid>
      )}
      {question.hasDescription && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Typography variant="body1" mb={2} className='ques-desc'>
            {AUDIENCE.STAFF === audience
              ? question.staffDescription
              : AUDIENCE.PARENT == audience
                ? question.parentDescription
                : question.pupilDescription}
          </Typography>
        </Grid>
      )}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        {question.isTextOption && (
          <Stack direction="column" spacing={1}>
            <div className="radio-button-container">
              <RadioGroup value={value?.value}>
                {question?.multiOptionResponseAttributes
                  ?.sort((x, y) => x.order - y.order)
                  .map((option, index) => (
                    <FormControlLabel
                      control={
                        <Radio
                          checked={response[`value${index + 1}`] !== null}
                          onChange={e => setSelectedOption(option)}
                          //   {
                          //   setValue(option)
                          //   let resp = {
                          //     ...response,
                          //     followupComment:
                          //       question.hasFollowup &&
                          //       question.followupQuestions.findIndex(
                          //         x => x.followupValue == value?.value
                          //       ) > -1
                          //         ? response.followupComment
                          //         : null,
                          //   }
                          //   
                          //   resp[`valueText1`] =
                          //     audience === AUDIENCE.STAFF
                          //       ? option.staffText
                          //       : AUDIENCE.PARENT == audience
                          //         ? option.parentText
                          //         : option.pupilText
                          //   resp[`numValue1`] =
                          //     question.hasCustomValue && option.numValue
                          //       ? option.numValue
                          //       : null

                          //   resp['staffQuestion'] = question.staffText
                          //   resp['parentQuestion'] = question.parentText
                          //   resp['studentQuestion'] = question.pupilText

                          //   question?.multiOptionResponseAttributes.map(
                          //     (op, i) => {
                          //       if (op.value === option.value) {
                          //         resp[`value${i + 1}`] = option.value
                          //       } else {
                          //         resp[`value${i + 1}`] = null
                          //       }
                          //     }
                          //   )
                          //   setResponse(resp)
                          //   if (updateAnswers) {
                          //     updateAnswers(resp)
                          //   }
                          // }
                          //}
                        />
                      }
                      label={
                        AUDIENCE.STAFF === audience
                          ? option.staffText
                          : AUDIENCE.PARENT == audience
                            ? option.parentText
                            : option.pupilText
                      }
                    />
                  ))}
              </RadioGroup>
            </div>
          </Stack>
        )}

        {question.isEmojiOption && (
          <Stack
            direction="row"
            spacing={{xs: 5, sm: 5, md: 7}}
            useFlexGap
            justifyContent={'center'}
            flexWrap={'wrap'}
            rowGap={{xs: 3, sm: 5, md: 7}}
            mt={2}
          >
            {question?.multiOptionResponseAttributes
              ?.sort((x, y) => x.order - y.order)
              .map((option, index) => (
                <Stack
                  direction="column"
                  spacing={1}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <div
                    style={{
                      border:
                        value?.value === option.value
                          ? '2px solid #E84F6B'
                          : '2px solid transparent',
                    }}
                  >
                    {option.staffEmoji ||
                    option.parentEmoji ||
                    option.pupilEmoji ? (
                      <IconButton
                        onClick={e => setSelectedOption(option)}
                        disableRipple
                      >
                        <SurveyEmoji
                          unified={
                            audience === AUDIENCE.STAFF
                              ? option.staffEmoji
                              : audience === AUDIENCE.PARENT
                                ? option.parentEmoji
                                : option.pupilEmoji
                          }
                          size={66}
                        />
                      </IconButton>
                    ) : (
                      <DummyImage width={98} height={72} />
                    )}
                  </div>
                  <div style={{marginTop: 10}}>
                    <Typography variant="body1">
                      {audience === AUDIENCE.STAFF && option.showStaffEmojiLabel
                        ? option.staffText
                        : ''}
                      {audience === AUDIENCE.PARENT &&
                      option.showParentEmojiLabel
                        ? option.parentText
                        : ''}
                      {audience === AUDIENCE.STUDENT &&
                      option.showPupilEmojiLabel
                        ? option.pupilText
                        : ''}
                    </Typography>
                  </div>
                </Stack>
              ))}
          </Stack>
        )}

        {question.isImageOption && (
          <Stack
            direction="row"
            columnGap={{xs: 5, sm: 5, md: 7}}
            useFlexGap
            justifyContent={'center'}
            flexWrap={'wrap'}
            rowGap={{xs: 3, sm: 5, md: 7}}
            mt={2}
          >
            {question?.multiOptionResponseAttributes
              ?.sort((x, y) => x.order - y.order)
              .map((option, index) => (
                <Stack
                  direction="column"
                  spacing={1}
                  alignContent={'center'}
                  justifyContent={'center'}
                >
                  <div
                    style={{
                      border:
                        value?.value === option.value
                          ? '2px solid #E84F6B'
                          : '2px solid transparent',
                    }}
                  >
                    <IconButton
                      onClick={e => setSelectedOption(option)}
                      disableRipple
                      sx={{padding: 0}}
                    >
                      {option.staffImage ||
                      option.parentImage ||
                      option.pupilImage ? (
                        <img
                          src={`${Config.BASE_URL}/Artifact/download?fileName=${
                            audience === AUDIENCE.STAFF
                              ? option.staffImage
                              : audience === AUDIENCE.PARENT
                                ? option.parentImage
                                : option.pupilImage
                          }`}
                          style={{width: 200, height: 'auto'}}
                        />
                      ) : (
                        <DummyImage width={98} height={72} />
                      )}
                    </IconButton>
                  </div>
                  <div style={{marginTop: 10}}>
                    <Typography variant="body1">
                      {option.showStaffImageLabel && AUDIENCE.STAFF === audience
                        ? option.staffText
                        : ''}
                      {option.showParentImageLabel &&
                      AUDIENCE.PARENT === audience
                        ? option.parentText
                        : ''}
                      {option.showPupilImageLabel &&
                      AUDIENCE.STUDENT === audience
                        ? option.pupilText
                        : ''}
                    </Typography>
                  </div>
                </Stack>
              ))}
          </Stack>
        )}
        {question.hasFollowup &&
          question.followupQuestions.findIndex(
            x => x.followupValue === value?.value
          ) > -1 && (
            <Stack direction="column" spacing={2} mt={1}>
              <Stack>
                <Typography variant="h2">
                  {AUDIENCE.STAFF === audience
                    ? question.followupQuestions[
                        question.followupQuestions.findIndex(
                          x => x.followupValue === value?.value
                        )
                      ]?.staffFollowupText
                    : AUDIENCE.PARENT === audience
                      ? question.followupQuestions[
                          question.followupQuestions.findIndex(
                            x => x.followupValue === value?.value
                          )
                        ]?.parentFollowupText
                      : question.followupQuestions[
                          question.followupQuestions.findIndex(
                            x => x.followupValue === value?.value
                          )
                        ]?.pupilFollowupText}
                </Typography>
              </Stack>

              <Stack>
                <TextField
                  multiline
                  rows={4}
                  label={'Enter your comment'}
                  value={response.followupComment}
                  onChange={e => {
                    setResponse({
                      ...response,
                      followupComment: e.target.value,
                    })

                    if (updateAnswers) {
                      updateAnswers({
                        ...response,
                        followupComment: e.target.value,
                      })
                    }
                  }}
                ></TextField>
              </Stack>
            </Stack>
          )}
      </Grid>
    </Grid>
  )
}
